import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const TickerSubmissionContainer = styled(FlexContainer)`
  gap: 16px;
  width: 100%;
  padding: 16px 0;
`
